import LoadingButton from '@mui/lab/LoadingButton';
import React from 'react';
import { SxProps, Theme } from '@mui/material';

export interface CtaButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  children: React.ReactNode;
  startIcon?: React.ReactNode;
  sx?: SxProps<Theme> | undefined;
  disabled?: boolean;
  color?: 'success' | 'error' | undefined;
  type?: 'button' | 'reset' | 'submit';
  loading?: boolean;
  autoFocus?: boolean;
  /* eslint-disable-next-line */
  onClick?: (e: any) => any;
}

export function CtaButton({
  variant,
  children,
  sx = {},
  onClick,
  ...other
}: CtaButtonProps) {
  return (
    <LoadingButton
      sx={{ textTransform: 'none', px: 3, ...sx }}
      variant={variant}
      disableElevation
      onClick={onClick}
      {...other}
    >
      {children}
    </LoadingButton>
  );
}

export default CtaButton;
